import React from 'react';
import styled from 'styled-components';
import {
    Drawer as AntDrawer, Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { SlideImage } from '../ProceedTopUp.style';
import { Slide } from "react-slideshow-image";

const Drawer = styled(AntDrawer)`
border-top-left-radius: 25px;
border-top-right-radius: 25px;
position: relative;

.ant-drawer-body {
    padding: 20px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media screen and (max-width: 360px) {
        padding: 16px 8px 8px 8px;
    }
}

.indicators {
    padding: 0 !important;
}

.react-slideshow-container+ul.indicators .each-slideshow-indicator:before {
background-color: #C21C05;
}

.ant-btn-primary {
    height: 52px !important;
    margin-top: 20px;
}
`;

const Title = styled.div`
padding-bottom: 8px;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #C21C05;
text-align: center;

@media screen and (max-width: 360px) {
    font-size: 16px;
}
`;

const Text = styled.div`
padding-bottom: 32px;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 24px;
color: #808080;
text-align: center;

@media screen and (max-width: 360px) {
    font-size: 13px;
}
`;

const SampleDrawer = ({
    active_topup_screenshot,
    receiving_account,
    open,
    handleClose,
}) => {
    const { t } = useTranslation();

    return (
        <Drawer
            destroyOnClose
            size='large'
            autoFocus={false}
            closable={false}
            getContainer={false}
            placement='bottom'
            open={open}
            onClose={handleClose}
        >
            <Title>{!active_topup_screenshot && t("wallet.topupSampleDrawerTitle")}</Title>
            <Text>{!active_topup_screenshot && t("wallet.topupSampleDrawerSubTitle")}</Text>
            {((!active_topup_screenshot && receiving_account?.payment_category_view_sample_images?.length > 0) ||
                (active_topup_screenshot && receiving_account?.payment_category_view_topup_images?.length > 0))
                && (
                    <Slide
                        arrows={false}
                        autoplay={true}
                        indicators={true}
                        duration={3000}
                        transitionDuration={500}
                    >
                        {active_topup_screenshot
                            ? receiving_account?.payment_category_view_topup_images?.map(
                                (image, key) => (
                                    <SlideImage key={key} src={image} />
                                )
                            )
                            : receiving_account?.payment_category_view_sample_images?.map(
                                (image, key) => (
                                    <SlideImage key={key} src={image} />
                                )
                            )}
                    </Slide>
                )}
            <Button
                type='primary'
                size='large'
                onClick={handleClose}
            >
                {t("common.ok")}
            </Button>
        </Drawer>
    )
}

export default SampleDrawer